// Google blocks its sign-in inside in-app browsers (WhatsApp, Instagram,
// Facebook, LINE, Android web views), so there the email link is the only path.
const IN_APP_BROWSER = /FBAN|FBAV|Instagram|WhatsApp|Line\/|; wv\)/i;

export const googleAvailable = (): boolean =>
  !!import.meta.env.VITE_GOOGLE_CLIENT_ID &&
  typeof navigator !== 'undefined' &&
  !IN_APP_BROWSER.test(navigator.userAgent);

/** The server asks for a recent real sign-in before a sensitive action. */
export const REAUTH_CODE = 'RESIDENT_REAUTH_REQUIRED';
